"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconArrayCreator = exports.showAverageRating = void 0;
const react_1 = __importDefault(require("react"));
const showAverageRating = (aggregateRating) => {
    if (!aggregateRating) {
        return false;
    }
    return (typeof aggregateRating.rating_count === 'number' &&
        aggregateRating.rating_count > 0 &&
        typeof aggregateRating.average_rating === 'number');
};
exports.showAverageRating = showAverageRating;
/**
 * Method to create an array of JSX icons.
 * @param {Component} Icon The Icon to populate the array.
 * @param {number} num The desired length of the icon array.
 * @param {size} num The desired size of the icon.
 * @return {JSX[]} An array with all the icons.
 */
const iconArrayCreator = (Icon, num, size) => {
    const icons = [];
    for (let i = 0; i < num; i++) {
        icons.push(react_1.default.createElement(Icon, { size: `${size}px`, key: `${Icon.displayName}-${i}`, "aria-hidden": true }));
    }
    return icons;
};
exports.iconArrayCreator = iconArrayCreator;
//# sourceMappingURL=index.js.map